<div class="rv-flex item-container">
  <ng-container *ngIf="contentSize != null">
    <svg
      width="21px"
      [attr.height]="contentSize.height + 'px'"
      [attr.viewBox]="'0 0 21 ' + contentSize.height"
    >
      <circle cx="7.5" cy="13" r="7.5" stroke="#dedde4" fill="none"></circle>
      <line
        *ngIf="!last"
        x1="7.5"
        y1="20.5"
        x2="7.5"
        [attr.y2]="contentSize.height"
        stroke="#dedde4"
      ></line>
      <line
        *ngIf="!first"
        x1="7.5"
        y1="6"
        x2="7.5"
        y2="0"
        stroke="#dedde4"
      ></line>
    </svg>
  </ng-container>
  <div (clientSize)="contentSize = $event" #item class="item">
    <div [rivTooltip]="showTooltip ? event.displayContent : undefined">
      {{ event.displayContent }}
    </div>
    <span class="gray">
      {{ event.date | rivDate: 'MM/dd/yyyy hh:mm a'
      }}<span *ngIf="event.username"> by {{ event.username }}</span>
    </span>
  </div>
</div>
